import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from './../icon/icon.module';
import { OfferStatusIndicatorComponent } from './offer-status-indicator.component';

@NgModule({
  declarations: [OfferStatusIndicatorComponent],
  imports: [CommonModule, IconModule],
  exports: [OfferStatusIndicatorComponent],
})
export class OfferStatusIndicatorModule {}
export { OfferStatusIndicatorComponent } from './offer-status-indicator.component';
